// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"R","newsBannerBox":"R","banner-wrap":"S","bannerWrap":"S","banner-title":"T","bannerTitle":"T","banner-img-box":"U","bannerImgBox":"U"};